export default __webpack_public_path__ + "static/media/about-mid.c419d255.jpg";